import { render, staticRenderFns } from "./UserAccountDetailsBasicInformationBasic.vue?vue&type=template&id=08020866&"
import script from "./UserAccountDetailsBasicInformationBasic.vue?vue&type=script&lang=js&"
export * from "./UserAccountDetailsBasicInformationBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports